import { Routes, RouterModule } from '@angular/router';
import { EmployeesListComponent } from './employee-list/employees-list.component';
import { EmployeeDetailsModule } from './employee-details/employee-details.module';


const routes: Routes = [
  { path: '', component: EmployeesListComponent },
  { path: 'employee', loadChildren: () => EmployeeDetailsModule }
];

export const EmployeesListRouting = RouterModule.forChild(routes);
